import React, { useMemo } from 'react';
import { TAMIL_CINEMA_STARS } from '../data/tamilCinemaStars';

export function HeaderStarRoll() {
  const track = useMemo(
    () => [...TAMIL_CINEMA_STARS, ...TAMIL_CINEMA_STARS],
    []
  );

  return (
    <div className="gnews-header-star-roll" aria-hidden>
      <div className="gnews-header-star-roll-track">
        {track.map((star, index) => (
          <figure key={`${star.name}-${index}`} className="gnews-header-star-card">
            <img
              src={star.image}
              alt=""
              className="gnews-header-star-img"
              loading="lazy"
              decoding="async"
            />
          </figure>
        ))}
      </div>
    </div>
  );
}

export default HeaderStarRoll;
